import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Story from './components/Story';
import ProductGrid from './components/ProductGrid';
import Blog from './components/Blog';
import Cart from './components/Cart';
import Footer from './components/Footer';
import ProductModal from './components/ProductModal';
import { initAnalytics, logPageView } from './analytics';
import './App.css';

function App() {
  useEffect(() => {
    initAnalytics();
    logPageView('/');
  }, []);

  return (
    <BrowserRouter>
      <CartProvider>
        <div className="app" dir="rtl">
          <Header />
          <main>
            <Hero />
            <ProductGrid />
            <Story />
            <Blog />
          </main>
          <Footer />
          <Cart />
          <ProductModal />
        </div>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
